import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";

@Pipe({
  name: "rawDate",
})
export class RawDatePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: string, ...args) {
    if (value === null || value === undefined) {
      return "";
    }

    return moment(value, "YYYYMMDD").format("MM/DD/YYYY");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/raw-date.pipe.ts